import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import {
  SubscriptionBannerUpgradeComponent
} from '@components/subscription-banner/subscription-banner-upgrade/subscription-banner-upgrade.component';
import { DialogData } from '@client/shared/components/document/upload-document-dialog/upload-document-dialog.component';
import {
  SubscriptionChangeDialogComponent
} from '@client/shared/components/subscription/subscription-change-dialog/subscription-change-dialog.component';

@Component({
  selector: 'app-subscription-banner-upgrade-sole',
  templateUrl: './subscription-banner-upgrade-sole.component.html',
  styleUrls: ['./subscription-banner-upgrade-sole.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SubscriptionBannerUpgradeSoleComponent {
  private dialogRef = inject(MatDialogRef<SubscriptionBannerUpgradeComponent>);
  public dialog = inject(MatDialog);
  public data = inject<DialogData>(MAT_DIALOG_DATA);

  

  openSubscriptionDialog(): void {
    this.dialog.open(SubscriptionChangeDialogComponent, {
      panelClass: 'dialog-extra-large',
    });

    this.dialogRef.close();
  }
}
